import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import routerGuard from './guard'
import events from '@/events'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      content: 'home',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/registro',
    name: 'registroParticipante',
    component: () =>
      import(
        /* webpackChunkName: "registroParticipante" */ '../views/RegisterParticipant.vue'
      ),
  },
  {
    path: '/registroposter/:id',
    name: 'registroposter',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Registro.vue'),
    meta: {
      content: 'userMenu',
    },
    props: route => {
      const { id } = route.params
      if (!id || id === 'nuevo') {
        return null
      }
      return { value: id }
    },
  },
  {
    path: '/recuperar',
    name: 'recuperar',
    component: () =>
      import(/* webpackChunkName: "recover" */ '../views/Recover.vue'),
  },
  {
    path: '/recupass',
    name: 'recupass',
    component: () =>
      import(/* webpackChunkName: "recover" */ '../views/RecoverPass.vue'),
  },
  {
    path: '/usuario',
    name: 'usuario',
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/Participante.vue'),
    meta: {
      content: 'userMenu',
    },
  },
  {
    path: '/revision',
    name: 'admin',
    component: () =>
      import(/* webpackChunkName; "admin" */ '../views/Admin.vue'),
    meta: {
      content: 'userMenu',
    },
  },
  {
    path: '/poster/:id',
    name: 'poster',
    component: () =>
      import(/* webpackChunkName: "poster" */ '../views/Poster.vue'),
    meta: {
      content: 'userMenu',
    },
    props: route => ({
      value: route.params.id,
    }),
  },
  {
    path: '/certificados',
    name: 'certificados',
    component: () =>
      import(/* webpackChunkName: "poster" */ '../views/Certificados.vue'),
  },
  {
    path: '/posters',
    name: 'posters',
    component: () => import('../views/PosterList.vue'),
    meta: {
      content: 'userMenu',
    },
  },
  {
    path: '/controlasistencia/:id_evento',
    name: 'ControlAsistencia',
    component: () => import('../views/Asistencia.vue'),
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach(routerGuard)
router.afterEach((to, from) => events.$emit('route', to, from))

export default router
